import React, { useState } from "react";
import { Loader2, Reply } from "lucide-react";
import { RECIPIENTS, runRound } from "../lib/boardRound";
import { AISourcePicker, emptyAISources } from "./AISourcePicker";

export function BoardReplyBox({ threadId, defaultRecipient, onDone }) {
  const [text, setText] = useState("");
  const [recipient, setRecipient] = useState(defaultRecipient || "buffett");
  const [busy, setBusy] = useState(false);
  const [src, setSrc] = useState(emptyAISources);

  const send = async () => {
    const q = text.trim();
    if (q.length < 3) return;
    setBusy(true);
    await runRound({ threadId, recipient, consultantIds: ["buffett", "jobs", "bezos"], question: q, src });
    setBusy(false);
    setText("");
    setSrc(emptyAISources());
    onDone?.();
  };

  return (
    <div data-testid="istoric-reply-box" className="rounded border border-accent-500/40 bg-white p-3">
      <div className="mb-2 flex flex-wrap items-center gap-2 text-xs text-slate-600">
        <Reply size={14} /> Raspunde la analiza catre
        <select data-testid="istoric-reply-recipient" value={recipient} onChange={(e) => setRecipient(e.target.value)} disabled={busy} className="rounded border border-slate-300 bg-white px-2 py-1 text-xs">
          {RECIPIENTS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
      </div>
      <AISourcePicker value={src} onChange={setSrc} disabled={busy} label="Surse suplimentare la raspuns" />
      <textarea
        data-testid="istoric-reply-input"
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) send(); }}
        rows={6}
        disabled={busy}
        placeholder="Informatii suplimentare / corecturi pentru analiza... (Ctrl+Enter pentru trimitere)"
        className="w-full resize-y rounded border border-slate-200 bg-slate-100 px-3 py-2 text-sm outline-none focus:border-accent-500"
      />
      <div className="mt-2 flex justify-end">
        <button data-testid="istoric-reply-send" type="button" onClick={send} disabled={busy || text.trim().length < 3} className="inline-flex items-center gap-1.5 rounded bg-accent-500 px-3 py-1.5 text-sm font-semibold text-ink-950 disabled:opacity-50">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <Reply size={14} />} {busy ? "Se genereaza analiza corectata..." : "Trimite raspuns"}
        </button>
      </div>
    </div>
  );
}
